import { WIDGET_HOME_TYPE_V2, WIDGET_TYPE_V2 } from '../common';
import { ValueOf } from '../../common/utils';
import { DateRageType } from '../../common/date';
import { Attachment } from '../../../components/input/ImageAndVideoUploadV2/types';
import {
  BannerWidgetsCreateRequestWidgetDto,
  BannerWidgetsCreateRequestWidgetDtoLayoutTypeEnum,
  BannerWidgetsCreateRequestWidgetItemBannerDto,
  BannerWidgetsFindOneResponseWidgetDto,
} from '../../api/widgets';
import { ProductItemV2 } from '../../product';
import { BrandItemV2 } from '../../brand/list';
import { EventItemV2 } from '../../event';
import { ReviewItemV2 } from '../../review/list';
import { TagItemV2 } from '../../tag';

export const BANNER_WIDGET_LAYOUT_TYPE_V2 = {
  SWIPE_MARGIN: 'swipeMargin',
  SWIPE_NO_MARGIN: 'swipeNoMargin',
  SWIPE_1_DOT_5: 'swipe1Dot5',
  SWIPE_2_DOT_5: 'swipe2Dot5',
  GRID_1X2: 'grid1x2',
  GRID_2X2: 'grid2x2',
  SCROLL_NX1: 'scrollNx1',
} as const;
export type BANNER_WIDGET_LAYOUT_TYPE_V2 = ValueOf<typeof BANNER_WIDGET_LAYOUT_TYPE_V2>;

export const BANNER_WIDGET_LINK_TYPE_V2 = {
  BRAND: 'brand',
  EVENT: 'event',
  PRODUCT_LIST: 'productList',
  BRAND_LIST: 'brandList',
  LIKE_PRODUCT_LIST: 'likeProductList',
  LIKE_BRAND_LIST: 'likeBrandList',
  CART: 'cart',
  POINT: 'point',
  COUPON: 'coupon',
  REFERRAL: 'referral',
  ORDER_DELIVERY_LIST: 'orderDeliveryList',
  PRODUCT_REVIEW_WRITE_TAB: 'productReviewWriteTab',
  PRODUCT_REVIEW_HISTORY_TAB: 'productReviewHistoryTab',
  UPDATE_USER: 'updateUser',
  SET_ALARM: 'setAlarm',
  PRODUCT: 'product',
  REVIEW: 'review',
  TAG_TAB: 'tagTab',
  TAG_DETAIL_GALLERY: 'tagDetailGallery',
  TAG_DETAIL_FEED: 'tagDetailFeed',
  WEB: 'web',
  CATEGORY: 'category',
} as const;

export type BANNER_WIDGET_LINK_TYPE_V2 = ValueOf<typeof BANNER_WIDGET_LINK_TYPE_V2>;

export const BANNER_WIDGET_ATTACHMENT_TYPE_V2 = {
  PC: 'pc',
  MOBILE: 'mobile',
} as const;

export type BANNER_WIDGET_ATTACHMENT_TYPE_V2 = ValueOf<typeof BANNER_WIDGET_ATTACHMENT_TYPE_V2>;

export type LinkItem = {
  id: number;
  name: string;
};

export type BannerWidgetSelectItem = ProductItemV2 | BrandItemV2 | EventItemV2 | ReviewItemV2 | TagItemV2;

export type WidgetItemBannerItem = {
  id: number;
  mobileImage: Required<Attachment>[];
  pcImage: Required<Attachment>[];
  memo: string;
  linkType: BANNER_WIDGET_LINK_TYPE_V2;
  link: LinkItem | null;
  linkUrl?: string;
  isUseBannerTitle: boolean;
  title?: string;
  contents?: string;
};

export class BannerWidgetDetailV2 {
  type: typeof WIDGET_TYPE_V2.BANNER;
  layoutType: BANNER_WIDGET_LAYOUT_TYPE_V2;
  mainTitle?: string;
  subTitle?: string;
  memo: string;
  exposurePeriod: DateRageType;
  currentExposurePage?: string;
  widgetItemBanners: WidgetItemBannerItem[];
  constructor(detail: BannerWidgetsFindOneResponseWidgetDto) {
    this.type = detail.type;
    this.layoutType = detail.layoutType;
    this.mainTitle = detail.mainTitle;
    this.subTitle = detail.subTitle;
    this.memo = detail.memo;
    this.exposurePeriod = {
      startDate: detail.exposureStartDate,
      endDate: detail.exposureEndDate,
    };
    this.currentExposurePage = detail.home?.type === WIDGET_HOME_TYPE_V2.MAIN ? '메인 페이지' : detail.home?.title;
    this.widgetItemBanners = detail.widgetItemBanners.map((item) => {
      const mobileImage = item.widgetItemBannerAttachments.find(
        (attachment) => attachment.type === BANNER_WIDGET_ATTACHMENT_TYPE_V2.MOBILE,
      );
      const pcImage = item.widgetItemBannerAttachments.find(
        (attachment) => attachment.type === BANNER_WIDGET_ATTACHMENT_TYPE_V2.PC,
      );

      return {
        id: item.id,
        mobileImage: mobileImage ? [mobileImage] : [],
        pcImage: pcImage ? [pcImage] : [],
        memo: item.memo,
        linkType: item.linkType,
        link: item.linkId
          ? {
              id: item.linkId,
              name: item.linkName,
            }
          : null,
        linkUrl: item.linkUrl,
        isUseBannerTitle: !!item.title,
        title: item.title,
        contents: item.contents,
      };
    });
  }
}

export class BannerWidgetRequestPayloadV2 implements BannerWidgetsCreateRequestWidgetDto {
  mainTitle: string;
  subTitle: string;
  memo: string;
  exposureStartDate: string | null;
  exposureEndDate: string | null;
  layoutType: BannerWidgetsCreateRequestWidgetDtoLayoutTypeEnum;
  widgetItemBanners: Array<BannerWidgetsCreateRequestWidgetItemBannerDto>;
  constructor(detail: BannerWidgetDetailV2) {
    this.mainTitle = detail.mainTitle || '';
    this.subTitle = detail.subTitle || '';
    this.memo = detail.memo || '';
    this.layoutType = detail.layoutType;
    this.exposureStartDate = detail.exposurePeriod.startDate && new Date(detail.exposurePeriod.startDate).toISOString();
    this.exposureEndDate = detail.exposurePeriod.endDate && new Date(detail.exposurePeriod.endDate).toISOString();
    this.layoutType = detail.layoutType;
    this.widgetItemBanners = detail.widgetItemBanners.map((item) => ({
      linkType: item.linkType,
      linkId: item.link?.id,
      linkUrl: item.linkUrl || '',
      memo: item.memo,
      title: item.isUseBannerTitle && item.title ? item.title : '',
      contents: item.isUseBannerTitle && item.contents ? item.contents : '',
      widgetItemBannerAttachments: [
        { ...item.mobileImage[0], type: BANNER_WIDGET_ATTACHMENT_TYPE_V2.MOBILE },
        { ...item.pcImage[0], type: BANNER_WIDGET_ATTACHMENT_TYPE_V2.PC },
      ],
    }));
  }
}
